// extracted by mini-css-extract-plugin
export var audio = "styles-module--audio--2dcr-";
export var figure = "styles-module--figure--2ITQa";
export var image = "styles-module--image--TpMBb";
export var table = "styles-module--table--2Rql8";
export var video = "styles-module--video--3Ojkk";